import React from "react";
import Beverages from "../../../images/product-images/remove-bg/beverages.png";
import { db, database } from "../../../firebase-config";
import "firebase/database";
import { getDocs, collection } from "firebase/firestore";
import { useEffect } from "react";
import { useState } from "react";
import "./../productList.css";
import DisplayProducts from "../DisplayProducts";
import Popup from "../Popup/Popup";

export const ColdDrinks = () => {
  const [beverages, setBeverages] = useState([]);
  const collectionRef = collection(db, "beverages");

  useEffect(() => {
    const getBeverages = async () => {
      const data = await getDocs(collectionRef);
      // console.log(data);

      setBeverages(
        data.docs.map((doc) => ({
          ...doc.data(),
        }))
      );

      // console.log(data.docs);
    };

    getBeverages();
  }, []);

  return (
    <>
      <div className="cold-drinks">
        <div className="productHEaderDiv">
          <h2 className="productHeader">BEVERAGES</h2>
          <h2 className="productHeader">BEVERAGES</h2>
        </div>
        <img className="cold-drinks-img" src={Beverages} />
      </div>



      <div className="individualPdts">
        {beverages.map((beverage,index) => {
          return <span key={index}>
            {DisplayProducts(
              index,
            beverage.name,
            beverage.desc,
            beverage.price,
            beverage.productImage,
            beverage.qty,
            beverage.vol
          )}
          </span>
        })}
      </div>
    </>
  );
};
